
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomahabaleshwarinnova() {



    const cardData =
    {
        keyword: ' Pune to Mahabaleshwar Innova Cab',
        heading: 'Prince Cabs: Pune to Mahabaleshwar Innova Cab',
        headingDescription: 'Prince Cabs offers comfortable Pune to Mahabaleshwar Innova Cab services, perfect for family vacations, weekend getaways, corporate travel, and sightseeing tours. Our spacious Innova and Innova Crysta vehicles are well-maintained and equipped with modern amenities, ensuring a safe and enjoyable ride through the scenic ghats. With professional chauffeurs, on-time pickups, and flexible schedules, we make your Pune to Mahabaleshwar journey smooth and hassle-free. Experience comfort, affordability, and reliability with Prince Cabs’ trusted Innova cab service from Pune to Mahabaleshwar.',

        top: 'Top Places to Visit in Mahabaleshwar with Prince Cabs',

      "topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is one of the most popular attractions in Mahabaleshwar, known for its serene waters and surrounding greenery. Visitors enjoy boating, horse riding, and evening walks along the lakeside. Street stalls serve local snacks like corn and strawberries with cream, adding to the charm. The lake is especially lively during weekends and holidays. Families, couples, and groups love the refreshing atmosphere. It is the perfect spot to begin exploring Mahabaleshwar."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a must-visit destination, famous for its strawberry produce and food court. Visitors enjoy fresh strawberry milkshakes, ice creams, and the signature strawberries with cream. The garden also hosts the annual Strawberry Festival, attracting large crowds. The landscaped area, kids’ play zone, and retail shop selling jams, syrups, and chocolates make it a family-friendly spot. It is both a foodie’s paradise and a nature retreat. Mapro Garden is a highlight of Mahabaleshwar tourism."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort, built by Chhatrapati Shivaji Maharaj in 1656, is a historic landmark near Mahabaleshwar. The fort is famous for the Battle of Pratapgad where Shivaji defeated Afzal Khan. Visitors explore its towering walls, temples, and scenic viewpoints. The trek up the fort offers breathtaking valley views. History lovers admire its strategic design and cultural importance. It remains a symbol of Maratha valor and pride."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point, also called Sunrise Point, is the highest point in Mahabaleshwar at 1,439 meters. It offers panoramic views of the Sahyadri mountains and stunning sunrises. Visitors also enjoy sunsets and clear starry skies from this spot. It has three observation towers for different perspectives. Photographers and nature lovers find it captivating throughout the year. It is a must-visit for those seeking natural beauty."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a unique rock formation resembling an elephant’s trunk, making it one of Mahabaleshwar’s most iconic viewpoints. It overlooks the deep valleys of the Sahyadris, offering spectacular landscapes. The cool breeze and mist add to the experience, especially during monsoon. Tourists love capturing pictures of the natural wonder. It is a popular stop for families and groups. Elephant’s Head Point combines nature and curiosity."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat is called the ‘Queen of Points’ in Mahabaleshwar, offering breathtaking views of the valleys and the Savitri River. It is known for its optical illusion where lighter objects seem to float when thrown into the valley. The viewpoint is surrounded by lush greenery and multiple smaller points like Echo Point and Tiger Spring. Tourists find it both fun and scenic. It is one of the most visited viewpoints in the region."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is a spectacular natural attraction near Mahabaleshwar, especially beautiful during the monsoon season. The waterfall cascades from a height of 600 feet, creating a mesmerizing sight. Visitors can view it from safe platforms or trek closer to the smaller falls. The surrounding forest adds to its charm. It is a favorite for nature lovers and photographers. The sound of gushing water makes it a peaceful retreat."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "Mahabaleshwar Temple, dedicated to Lord Shiva, is an ancient shrine that gave the town its name. The temple houses a swayambhu (self-originated) lingam, making it highly revered. Its Hemadpanti-style stone architecture adds heritage value. Pilgrims and tourists alike find it spiritually enriching. The temple is surrounded by scenic hills, adding to its sacred vibe. It is both a religious and cultural landmark of Mahabaleshwar."
  },
  {
    "title": "Panch Ganga Temple",
    "description": "The Panch Ganga Temple is a sacred site where five rivers—Krishna, Venna, Koyna, Savitri, and Gayatri—are believed to originate. Built in the 13th century by Raja Singhandeo of the Yadava dynasty, it holds immense religious importance. Devotees visit to take blessings and experience the holy confluence. Its historic architecture and spiritual aura attract many pilgrims. It is a unique combination of mythology and heritage. The temple enhances Mahabaleshwar’s spiritual appeal."
  },
  {
    "title": "Connaught Peak",
    "description": "Connaught Peak, formerly known as Mount Olympia, is the second-highest point in Mahabaleshwar. It offers panoramic views of Venna Lake, Krishna Valley, and Pratapgad Fort. The spot is popular among trekkers and nature lovers. It is a peaceful alternative to the busier viewpoints. Sunsets here are breathtaking with golden skies over green valleys. Connaught Peak is ideal for those seeking solitude and scenic beauty."
  }
],


     "services": [
    {
        "name": "Pune to Mahabaleshwar Innova Crysta",
        "description": "Travel comfortably from Pune to Mahabaleshwar in a spacious and luxurious Innova Crysta. Ideal for family trips, corporate travel, and leisure outings, our Innova Crysta offers premium comfort, ample luggage space, and smooth ride quality. Experience reliable service with professional drivers who prioritize your safety and convenience throughout the journey."
    },
    {
        "name": "Pune to Mahabaleshwar Innova Package",
        "description": "Book our exclusive Innova package for Pune to Mahabaleshwar trips, designed for seamless travel with fixed rates, flexible timings, and comfortable vehicle options. Whether it’s a day trip or a multi-day tour, enjoy hassle-free booking, clean vehicles, and courteous drivers to make your hill station experience memorable and stress-free."
    },
    {
        "name": "Pune to Mahabaleshwar Innova Crysta Cab Booking",
        "description": "Easily book an Innova Crysta cab from Pune to Mahabaleshwar online with instant confirmation and customer-friendly policies. Our cabs are well-maintained and sanitized, perfect for family vacations, group travel, or corporate outings. Enjoy punctual pickups and drop-offs with experienced chauffeurs who know the route well."
    },
    {
        "name": "Pune to Mahabaleshwar Innova Crysta Cab",
        "description": "Choose our Innova Crysta cab service for a luxurious and comfortable ride from Pune to Mahabaleshwar. With premium interiors, air-conditioning, and ample seating space, it’s perfect for relaxed travel. Our professional drivers ensure a safe and pleasant journey, making stops at scenic points if desired."
    },
    {
        "name": "Pune Airport to Mahabaleshwar Innova Cab",
        "description": "Get reliable and timely Innova cab service from Pune Airport to Mahabaleshwar, ideal for tourists and business travelers. Avoid the hassle of multiple transfers and enjoy direct, comfortable travel with spacious luggage capacity. Our drivers track your flight timings to ensure punctual pickups and smooth rides."
    },
    {
        "name": "Pune to Mahabaleshwar Family Innova",
        "description": "Plan your family trips from Pune to Mahabaleshwar with our spacious Innova cab, offering comfortable seating for everyone along with extra room for luggage. Perfect for family outings, reunions, and vacations, our vehicles are equipped with all amenities to make your journey enjoyable and safe."
    },
    {
        "name": "Pune to Mahabaleshwar Innova Round Trip",
        "description": "Opt for our round trip Innova service from Pune to Mahabaleshwar to enjoy flexible travel schedules and cost-effective packages. Whether you need a day tour or an extended stay, our round trip cabs offer hassle-free booking, well-maintained vehicles, and courteous drivers for a stress-free travel experience."
    },
    {
        "name": "Pune to Mahabaleshwar Innova Dzire Alternative",
        "description": "If you prefer an upgrade from a Dzire, our Innova cabs provide a more spacious and comfortable alternative for Pune to Mahabaleshwar trips. Enjoy enhanced legroom, better suspension, and premium features in the Innova for a superior travel experience without compromising on affordability."
    },
    {
        "name": "Luxury Innova Pune to Mahabaleshwar",
        "description": "Travel in style with our luxury Innova services from Pune to Mahabaleshwar, perfect for those seeking a premium and sophisticated journey. With plush interiors, advanced features, and top-notch customer service, our luxury Innova cabs ensure your trip is not only comfortable but also elegant and memorable."
    }
],
"tableData": [
    ["Pune to Mahabaleshwar Innova Crysta", "Pune to Mahabaleshwar Innova Package"],
    ["Pune to Mahabaleshwar Innova Crysta Cab Booking", "Pune to Mahabaleshwar Innova Crysta Cab"],
    ["Pune Airport to Mahabaleshwar Innova Cab", "Pune to Mahabaleshwar Family Innova"],
    ["Pune to Mahabaleshwar Innova Round Trip", "Pune to Mahabaleshwar Innova Dzire Alternative"],
    ["Luxury Innova Pune to Mahabaleshwar", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Mahabaleshwar Innova Cab Service",
        "WhyChoosedescription": "Prince Cabs provides premium Toyota Innova cab services from Pune to Mahabaleshwar, perfect for families, groups, and corporate travelers. Our spacious and well-maintained Innova vehicles offer a smooth and comfortable journey through the scenic Western Ghats, making your trip enjoyable from start to finish."
    },
    {
        "WhyChooseheading": "Spacious Interiors and Modern Amenities",
        "WhyChoosedescription": "Our Innova cabs come with ergonomic seating, ample legroom, and large luggage capacity, ensuring comfort on the winding routes to Mahabaleshwar. Equipped with air conditioning and infotainment options, our vehicles make long-distance travel relaxing and pleasant."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Expertise in Hill Routes",
        "WhyChoosedescription": "Our professional drivers are skilled in navigating the hilly terrain and traffic conditions between Pune and Mahabaleshwar. They prioritize your safety with cautious driving and ensure timely pickups and drop-offs for a hassle-free experience."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Itinerary",
        "WhyChoosedescription": "Whether you require a one-way trip, round trip, or multi-day rental for sightseeing in Mahabaleshwar, Prince Cabs offers customizable packages. Book easily via phone, WhatsApp, or online portal, with instant confirmations and transparent pricing."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Measures",
        "WhyChoosedescription": "All Innova cabs are thoroughly cleaned and sanitized before and after each journey. We follow strict safety protocols to provide a clean, secure, and comfortable travel environment throughout your Pune to Mahabaleshwar trip."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Payment Options",
        "WhyChoosedescription": "Our pricing is competitive and transparent, with no hidden charges. We accept secure payments through UPI, credit/debit cards, net banking, and cash, making the booking and payment process convenient and worry-free."
    },
    {
        "WhyChooseheading": "Dedicated 24/7 Customer Support",
        "WhyChoosedescription": "Our customer support team is available around the clock to assist you with your Pune to Mahabaleshwar Innova cab booking, ensuring smooth coordination, prompt responses, and a hassle-free travel experience."
    }
]

















    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Innova cab service from Pune to Mahabaleshwar?',
        answer: 'Yes, Prince Cabs offers comfortable and reliable Innova cab services from Pune to Mahabaleshwar for day trips, overnight stays, and multi-day tours.',
    },
    {
        question: 'What is the approximate travel time from Pune to Mahabaleshwar by Innova cab?',
        answer: 'The journey typically takes around 3 to 4 hours depending on traffic and road conditions, ensuring a smooth and scenic ride.',
    },
    {
        question: 'What is the fare for an Innova cab from Pune to Mahabaleshwar?',
        answer: 'Fares start from ₹3,500 for a one-way trip. Pricing may vary based on travel date, duration, and any additional stops.',
    },
    {
        question: 'Can I book an Innova cab for a round trip between Pune and Mahabaleshwar?',
        answer: 'Yes, Prince Cabs offers both one-way and round-trip packages tailored to your travel needs with flexible timings and stopovers.',
    },
    {
        question: 'Are tolls and parking charges included in the fare?',
        answer: 'Tolls and parking charges are usually extra and will be clearly communicated at the time of booking for transparency.',
    },
    {
        question: 'Are the Innova cabs sanitized and maintained for this route?',
        answer: 'Absolutely! All Innova cabs are regularly sanitized and serviced to ensure your safety and comfort during the trip.',
    },
    {
        question: 'How do I book an Innova cab from Pune to Mahabaleshwar?',
        answer: 'You can book online via our website or call our support team with your travel details, and we will arrange a well-maintained Innova cab for your journey.',
    },
];

const testimonials = [
    {
        name: "Mr. Arjun Patil",
        position: "Weekend Traveler",
        text: "Booked an Innova cab from Pune to Mahabaleshwar with Prince Cabs. The trip was comfortable, the driver was courteous, and the service was excellent.",
        image: "/img/testimonial/testimonial-thumb-mahabaleshwar-1.png",
    },
    {
        name: "Mrs. Sneha Joshi",
        position: "Family Traveler",
        text: "Our family trip to Mahabaleshwar was delightful with Prince Cabs. The Innova was spacious, clean, and perfect for the hilly drive. Highly recommend!",
        image: "/img/testimonial/testimonial-thumb-mahabaleshwar-2.png",
    },
];
























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Innova Cab",
  "image": "https://princecab.com/assets/images/pune-to-mahabaleshwar-innova-cab.jpg",
  "description": "Book Pune to Mahabaleshwar Innova Crysta cab service with Prince Cabs for a comfortable, reliable, and luxury taxi experience. Available for family trips, round trips, and packages.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.75",
    "ratingCount": "7200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3800",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-mahabaleshwar-innova-cab"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune to Mahabaleshwar Innova Cab | Luxury & Reliable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Book Pune to Mahabaleshwar Innova Crysta cab service with Prince Cabs for a comfortable, reliable, and luxury taxi experience. Available for family trips, round trips, and packages."
  />
  <meta
    name="keywords"
    content="Pune to Mahabaleshwar Innova Crysta, Pune to Mahabaleshwar Innova Package, Pune to Mahabaleshwar Innova Crysta Cab Booking, Pune to Mahabaleshwar Innova Crysta Cab, Pune Airport to Mahabaleshwar Innova Cab, Pune to Mahabaleshwar Family Innova, Pune to Mahabaleshwar Innova Round Trip, Pune to Mahabaleshwar Innova Dzire Alternative, Luxury Innova Pune to Mahabaleshwar"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshwarinnova ;